<template>
  <div class="login-main">
    <!-- <img class="backgroup-img" src='../../images/backgroup_img.jpg'/> -->
    <div class="login-container">
        <router-view/>
    </div>
  </div>
</template>

<script>

export default {
  name: 'login'
}
</script>
<style scoped>
.login-main{
  height: 100%;
  width: 100%;
  text-align: center;
}
/* .backgroup-img{
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  position: absolute;
  z-index: -1;
} */
.login-container{
  top:20%;
  margin:1rem 30rem 1rem -12rem;
  display: inline-block;
  max-width: 26rem;
  max-height: 26rem;
  background:#e8eaec;
  position:absolute;
  border-radius: 1rem;
}
</style>
